import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
    open(event) {
        event.preventDefault()
        const url = event.currentTarget.href
        const frame = document.getElementById("contact_modal_frame")

        frame.src = url // Turbo will fetch the form into the frame

        frame.addEventListener("turbo:frame-load", () => {
            const modal = new bootstrap.Modal(document.getElementById("contactEditModal"))
            modal.show()
        }, { once: true })
    }
}